
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-teal-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/7a57d421-2c2a-46f2-8ebb-126e0217b520.png"
              alt="El Paso Bookkeeping Services - QuickBooks Bookkeeper"
              title="El Paso QuickBooks Bookkeeping Services"
              className="h-12 w-auto mb-4"
            />
            <p className="text-teal-200 text-sm leading-relaxed">
              Professional <strong>QuickBooks bookkeeping services</strong> for El Paso businesses. We help you maintain accurate financial records and make informed business decisions.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">
              <a href="/#services" className="hover:text-teal-300 transition-colors cursor-pointer">
                Services
              </a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#services" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Monthly Financial Reports</a></li>
              <li><a href="/#services" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Accounts Payable &amp; Receivable</a></li>
              <li><a href="/#services" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Bank Reconciliation</a></li>
              <li><a href="/#services" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Payroll Processing</a></li>
              <li><a href="/#services" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Financial Analysis</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">
              <a href="/#benefits" className="hover:text-teal-300 transition-colors cursor-pointer">
                Company
              </a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#benefits" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Why Choose Us</a></li>
              <li><a href="/#process" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">How It Works</a></li>
              <li><a href="/#testimonials" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Client Testimonials</a></li>
              <li><Link to="/blog" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Blog</Link></li>
              <li><a href="/#contact" className="text-teal-200 hover:text-teal-300 transition-colors cursor-pointer">Get Started</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Service Area</h4>
            <p className="text-teal-200 text-sm leading-relaxed mb-4">
              Proudly serving businesses throughout <strong>El Paso, Texas</strong> and the surrounding West Texas region including Las Cruces, NM.
            </p>
            <div className="flex space-x-4">
              <a href="#" rel="nofollow" aria-label="Facebook" className="w-10 h-10 bg-teal-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="Twitter" className="w-10 h-10 bg-teal-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="LinkedIn" className="w-10 h-10 bg-teal-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-300 text-sm">
              &copy; {currentYear} El Paso QuickBooks Bookkeeping Services. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-teal-300 hover:text-teal-200 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-teal-300 hover:text-teal-200 transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" rel="nofollow" className="text-teal-300 hover:text-teal-200 transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
